import { Environment } from 'environment.js'
import { get, post, put, remove } from 'Repository/index.js'
import type { Observable } from 'rxjs'
import type { IUser } from 'Model/index.js'
import type {
  IEmailNotification,
  IInviteContainer,
  ILabInvite,
  IOrderCompletedNotification,
  IProjectInvite
} from '../../Model/Invite/IInvite.js'

/**
 * Get all invites (both received and sent)
 */
export const getAllInvites = (user?: IUser): Observable<IInviteContainer> => {
  return get(`${Environment.API_URL}/api/invites/`, {}, user)
}

export const saveNewOrderCompletedNotification = (
  orderCompletedNotification: Omit<IOrderCompletedNotification, 'id' | 'orderName'>
): Observable<IOrderCompletedNotification> =>
  post(`${Environment.API_URL}/api/invites/`, { newOrderCompletedNotification: orderCompletedNotification })

export const updateOrderCompletedNotification = (
  orderCompletedNotification: Omit<IOrderCompletedNotification, 'orderName'>
): Observable<IOrderCompletedNotification> =>
  put(`${Environment.API_URL}/api/invites/orderCompletedNotifications/${orderCompletedNotification.id}`, {
    notification: orderCompletedNotification
  })

export const inviteLab = (
  orderId: string,
  data: {
    labEmail?: string
    organizationId?: string
    additionalText: string
  }
): Observable<ILabInvite> => {
  return post(`${Environment.API_URL}/api/orders/${orderId}/invite/`, data)
}
/**
 * Get a specific invite by ID
 */
export const getInviteById = (inviteId: number, user?: IUser): Observable<IEmailNotification> => {
  return get(`${Environment.API_URL}/api/invites/${inviteId}`, {}, user)
}

/**
 * Invite a participant to a project
 */
export const inviteProjectParticipant = (
  projectId: string,
  data: {
    participantEmail: string
    additionalText: string
    mayEdit: boolean
  },
  user?: IUser
): Observable<IProjectInvite> => {
  return post(`${Environment.API_URL}/api/projects/${projectId}/invites/`, data, user)
}

/**
 * Delete an invite by ID
 */
export const deleteInvite = (inviteId: number, user?: IUser): Observable<void> => {
  return remove(`${Environment.API_URL}/api/invites/${inviteId}`, user)
}
